import { Action } from 'redux';
import { Floor } from 'src/types/model';

export interface FloorState {
  loading: boolean;
  data: Floor[];
  error: string | null;
}

export const FETCH_FLOOR_REQUEST = 'FETCH_FLOOR_REQUEST';
export const FETCH_FLOOR_SUCCESS = 'FETCH_FLOOR_SUCCESS';
export const FETCH_FLOOR_FAILURE = 'FETCH_FLOOR_FAILURE';

export interface FetchFloorRequestAction
  extends Action<typeof FETCH_FLOOR_REQUEST> {}

export interface FetchFloorSuccessAction
  extends Action<typeof FETCH_FLOOR_SUCCESS> {
  payload: Floor[];
}

export interface FetchFloorFailureAction
  extends Action<typeof FETCH_FLOOR_FAILURE> {
  payload: string;
}

export type FloorActionType =
  | FetchFloorRequestAction
  | FetchFloorSuccessAction
  | FetchFloorFailureAction;
